import { useTranslations } from "use-intl";

import { parseDuration } from "@/utils/duration";

import {
  FlightInfo,
  type FlightInfoProps,
  FlightOverallTime,
} from "./flights/FlightInfo";

type Props = Pick<FlightInfoProps, "origin" | "destination"> & {
  duration: string | null;
  stops: number;
  operatedBy?: string;
};

export const SingleFlightInfo = ({
  origin,
  destination,
  duration,
  stops,
  operatedBy,
}: Props) => {
  const t = useTranslations();

  return (
    <FlightInfo origin={origin} destination={destination}>
      <div className="flex flex-col">
        <FlightOverallTime
          overallTime={
            duration ? t("durationValue", parseDuration(duration)) : null
          }
          stops={stops}
        />
        {operatedBy ? (
          <div className="text-center text-sm text-text-tertiary">{`${t("flights.flightOperatedBy")} ${operatedBy}`}</div>
        ) : null}
      </div>
    </FlightInfo>
  );
};
